import React from "react";

const head = {
  heading:"Revolutionise Alumni Engagement with Alumni Connect App!",
  description:"Welcome to the future of alumni relations at your institution! Alumni Connect App is the ultimate solution designed to strengthen ties between your school/college and its esteemed graduates."
}

const Database = [
  {
    "id": 1,
    "title": "Enhanced Alumni Networking",
    "description": "Seamlessly connect alumni from various classes and locations with personalized profiles and messaging. Foster networking opportunities effortlessly with Alumni Connect.",
    "icon": "fas fa-users"
  },
  {
    "id": 2,
    "title": "Dynamic Event Management",
    "description": "Streamline event organization and promote meaningful connections with ease.",
    "icon": "fas fa-calendar-alt"
  },
  {
    "id": 3,
    "title": "Tailored Communication Channels",
    "description": "Customize your groups based on interests and keep alumni engaged with targeted communications.",
    "icon": "fas fa-comments"
  },
  {
    "id": 4,
    "title": "Alumni Career Support",
    "description": "Empower graduates with job postings, mentorship, and resources. Facilitate networking through alumni-to-alumni connections for growth.",
    "icon": "fas fa-briefcase"
  },
  {
    "id": 5,
    "title": "Showcase Achievements and Milestones",
    "description": "Share successes, accolades, and milestones with Alumni Connect. Celebrate achievements and reinforce connections among graduates.",
    "icon": "fas fa-trophy"
  },
  {
    "id": 6,
    "title": "Comprehensive Analytics and Reporting",
    "description": "Gain insights into alumni engagement with analytics. Measure program effectiveness with impact measurement.",
    "icon": "fas fa-chart-line"
  }

];

const CoreValues = () => {
  return (
    <div className="core_values" id="hospital">
      <div className="container">
        <div className="comp_header">
          <h1>
           {head?.heading}
          </h1>
          <p>
            {head?.description}
          </p>
        </div>
        <div className="cards_wrapper">
          {Database?.map((data, idx) => (
            <div className="card">
              <div className="first">
                <i class={data?.icon}></i>
                <h3>{data?.title}</h3>
              </div>
              <div className="second">
                <p>
                {data?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreValues;
